import _omit from 'lodash/omit';

import { BaseCardContent } from '../components/ContentCard/BaseCard';

export const getAdaptedWideCardContent = (content: BaseCardContent) => {
  return _omit(content, ['progress', 'status']);
};

export default getAdaptedWideCardContent;
